import { useTranslation } from '@pasteltech/react-i18n'
import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import { styled } from 'styled-components'
import { FacebookIcon } from '../../svg-components'
import { ExternalLink } from '../external-link'

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) =>
    `${theme.sizes.spacings.md}px ${theme.sizes.spacings.xxl}px`};
  gap: ${({ theme }) => theme.sizes.spacings.xs}px;
  background-color: ${({ theme }) => theme.colors.facebook};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
  border: none;
  &:hover {
    cursor: pointer;
    background:
      linear-gradient(
        0deg,
        ${({ theme }) => theme.colors.ripple.high} 0%,
        ${({ theme }) => theme.colors.ripple.high} 100%
      ),
      ${({ theme }) => theme.colors.facebook};

    box-shadow:
      0 1px 2px 0 rgba(68, 70, 79, 0.2),
      0 2px 6px 2px rgba(68, 70, 79, 0.15);
  }
  &:active {
    background:
      linear-gradient(
        0deg,
        ${({ theme }) => theme.colors.hover.high} 0%,
        ${({ theme }) => theme.colors.hover.high} 100%
      ),
      ${({ theme }) => theme.colors.facebook};
    box-shadow:
      0 4px 8px 3px rgba(68, 70, 79, 0.2),
      0 1px 3px 0 rgba(68, 70, 79, 0.3);
  }
`
const Content = styled.div`
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  font-weight: ${FontWeight.medium};
  font-size: ${({ theme }) => theme.sizes.fontSize.button}px;
`
const StyledLink = styled(ExternalLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`

type Props = {
  to: string
}
export const FacebookButton = memo(({ to }: Props) => {
  const { t } = useTranslation()
  return (
    <StyledLink to={to}>
      <StyledButton>
        <FacebookIcon />
        <Content>{t('button.facebook')}</Content>
      </StyledButton>
    </StyledLink>
  )
})

FacebookButton.displayName = 'FacebookButton'
